// ** Reducers Imports
import layout from "./layout";
import navbar from "./navbar";
import user from "./reducer/userReducer";
import drawer from "./reducer/sidebar";

const rootReducer = { navbar, layout, user, drawer };

export default rootReducer;
